import React from 'react';

const SearchHighlight = ({ text, searchTerm }) => {
  if (!searchTerm || !text) return <span>{text}</span>;

  const regex = new RegExp(`(${searchTerm})`, 'gi');
  const parts = text?.split(regex);

  return (
    <span>
      {parts?.map((part, index) => 
        regex?.test(part) ? (
          <mark key={index} className="bg-yellow-200 px-1 rounded">
            {part}
          </mark>
        ) : (
          <span key={index}>{part}</span>
        )
      )}
    </span>
  );
};

export default SearchHighlight;